import React, { Fragment, useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { icons } from '../../../assets/icons';
import './index.scss';
import useOnclickOutside from 'react-cool-onclickoutside';
import AddAdmin from './addAdmin';
import UpdateAdmin from './UpdateAdmin';
import { adminBlocked, usersList, companiesForAdmins } from '../../../api/redux/slices/SuperAdmin';
import 'react-toastify/dist/ReactToastify.css';
import { useParams } from 'react-router-dom';
import { LoaderComponent } from '../../../helpers/components/loader';
import Pagination from '../../../helpers/components/Pagination';
import { showToast } from '../../../components/modal';

const AdminList = () => {
    const { list, loading, total, allCompanies } = useSelector((state) => state.superAdmin);
    const dispatch = useDispatch();
    const params = useParams();

    const [modalOpen, setModalOpen] = useState(false);
    const [updateModal, setUpdateModal] = useState(false);
    const [openDropdown, setOpenDropdown] = useState(false);
    const [indice, setIndice] = useState(null);
    const [page, setPage] = useState(Number(params.page));
    const [adminName, setAdminName] = useState('');
    const [typing, setTyping] = useState(false);
    const [selectedCompany, setSelectedCompany] = useState('');

    const ref = useOnclickOutside(() => {
        setOpenDropdown(false);
    });
    const token = localStorage.getItem('accesstoken');

    useEffect(() => {
        if (token) {
            dispatch(companiesForAdmins({ token }));
        }
    }, [token, dispatch]);

    const stableDispatch = useCallback(() => {
        dispatch(usersList({
            token: token,
            page: adminName ? undefined : page,
            search: adminName,
            company: selectedCompany || undefined,
        }));
    }, [dispatch, page, token, adminName, selectedCompany]);

    useEffect(() => {
        if (token) {
            stableDispatch();
        }
    }, [modalOpen, stableDispatch, adminName, token, selectedCompany]);

    const handleBlock = (e, id) => {
        e.preventDefault();
        dispatch(adminBlocked({ id: id, token: token, data: { is_active: false } }))
            .unwrap()
            .then(() => {
                setOpenDropdown(false);
                showToast('Utilisateur bloqué', 'success', 'bottom-right');
                stableDispatch();
            })
            .catch(() => showToast("Une erreur s'est produite", 'error', 'bottom-right'));
    };

    const handleUnblock = (e, id) => {
        e.preventDefault();
        dispatch(adminBlocked({ token: token, id: id, data: { is_active: true } }))
            .unwrap()
            .then(() => {
                setOpenDropdown(false);
                showToast('Utilisateur débloqué', 'success', 'bottom-right');
                stableDispatch();
            })
            .catch(() => showToast("Une erreur s'est produite", 'error', 'bottom-right'));
    };

    return (
        <div id='admin-list'>
            <div className='navbar'>
                <div className='left'>
                    <div className='nav-search'>
                        <input
                            type='text'
                            placeholder='Rechercher par nom...'
                            value={adminName}
                            onChange={(e) => {
                                setAdminName(e.target.value);
                                setTyping(true);
                            }}
                        />
                        <icons.FiSearch className='searchicon' />
                        {typing && (
                            <icons.GrFormClose
                                className='searchicon'
                                onClick={() => {
                                    setAdminName('');
                                    setTyping(false);
                                }}
                            />
                        )}
                    </div>
                    <div className='filters'>
                        <select
                            value={selectedCompany}
                            onChange={(e) => {
                                setSelectedCompany(e.target.value);
                                setPage(1);
                            }}
                        >
                            <option value=''>Toutes</option>
                            {(allCompanies || []).map((company) => (
                                <option key={company._id} value={company._id}>
                                    {company.name}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>
                <div className='right'>
                    <div className='right-items'>
                        <button className='button-primary' onClick={() => setModalOpen(!modalOpen)}>
                            <icons.SiAddthis />
                            <span>Admin</span>
                        </button>
                    </div>
                </div>
            </div>
            <div id='head'>
                <div className='title-user'>
                    <h1>Liste administrateurs</h1>
                </div>
            </div>
            <Fragment>
                <AddAdmin modalOpen={modalOpen} setModalOpen={setModalOpen} page={page} />
            </Fragment>
            <Fragment>
                {updateModal && (
                    <UpdateAdmin
                        updateModal={updateModal}
                        setUpdateModal={setUpdateModal}
                        indice={indice}
                        page={page}
                        stableDispatch={stableDispatch}
                    />
                )}
            </Fragment>
            <div className='mainContent'>
                <table className='content'>
                    <thead>
                        <tr className='titres'>
                            <td>ADMINISTRATEUR</td>
                            <td>EMAIL</td>
                            <td>TÉLÉPHONE</td>
                            <td>SOCIÉTÉ</td>
                            <td>STATUT</td>
                            <td>ACTION</td>
                        </tr>
                    </thead>
                    <tbody>
                        {loading ? (
                            <tr>
                                <td colSpan={6}>
                                    <LoaderComponent margin='10%' />
                                </td>
                            </tr>
                        ) : list?.length > 0 ? (
                            list.map((element) => (
                                <tr className='element' key={element._id}>
                                    <td style={{ textTransform: 'capitalize' }}>
                                        {element.first_name} {element.last_name}
                                    </td>
                                    <td>{element.email}</td>
                                    <td>{element.phone}</td>
                                    <td>{element.company?.name || '—'}</td> 
                                    <td
                                        className={element.is_active === true ? 'status' : 'status activé'}
                                        style={{ textTransform: 'capitalize' }}
                                    >
                                        {element.is_active === true ? 'Activé' : 'Bloqué'}
                                    </td>
                                    <td className='last-element'>
                                        <div className='contain'>
                                            <icons.BsThreeDotsVertical
                                                onClick={() => {
                                                    setOpenDropdown(!openDropdown);
                                                    setIndice(element._id);
                                                }}
                                                className='option'
                                            />
                                            {openDropdown && indice === element._id && (
                                                <div className='modalSelectOpt' ref={ref}>
                                                    <ul>
                                                        {element.is_active ? (
                                                            <li onClick={(e) => handleBlock(e, element._id)}>
                                                                Bloquer administrateur
                                                            </li>
                                                        ) : (
                                                            <li onClick={(e) => handleUnblock(e, element._id)}>
                                                                Débloquer administrateur
                                                            </li>
                                                        )}
                                                        <li onClick={() => setUpdateModal(!updateModal)}>
                                                            Modifier administrateur
                                                        </li>
                                                    </ul>
                                                </div>
                                            )}
                                        </div>
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan={6} style={{ textAlign: 'center', padding: '50px' }}>
                                    Aucun administrateur trouvé
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
            <Pagination page={page} setPage={setPage} pageLink={`/superadmin/users/`} total={total} />
        </div>
    );
};

export default AdminList;